<template>
	<el-select :remote="remote" :remote-method="remoteMethod" :loading="loading" v-model="option" filterable :clearable="noclearable ? false : true" :placeholder="placeholder" :size="size || 'small'" @input="change($event)" :disabled="disabled" @visible-change="visibleChange">
		<el-option v-for="item in list" :key="item.key" :label="showKey ? (item.name+' ('+item.key+')') : item.name" :value="item.key" :disabled="judgeState && item.disabled==0" />
	</el-select>
</template>

<script>
	import Vue, { Component } from 'C/BaseVue'
	import { model } from 'service/model'
	import mixin, { userMess } from 'M/mixin'
	import { getConstantByKeyword } from 'service/utils'

	@Component({
		props: ['placeholder', 'remote', 'disabled',  'groupName', 'result', 'isVisibleChange', 'isResultName', 'resultName', 'groupDate', 'filter', 'judgeState', 'showKey', 'noclearable','size','loading'],
		watch: {
			groupDate : {
				handler(curVal, oldVal){
					if(typeof curVal !== 'object') return false;
					this.list = curVal
				}
			},
			result : {
				handler(curVal, oldVal){
					this.option = curVal// || ''
				}
			},
			list : {
				handler(curVal, oldVal){
					if(!curVal.map(item => item.key).includes(this.result)){
						/* this.option = '' */
					}
				}
			}
		},
		mixins: [mixin, userMess]
	})

	export default class SelectTabs extends Vue {

		list = []
		option = ''
		mounted(){
			if(this.groupDate){
				this.list = this.groupDate
				this.$nextTick(()=>{
					!!this.result ? this.option = this.result : ''
					if(this.result==0){
						this.option = this.result
					}
				})
				/* !!this.result ? this.option = this.result : '' */
				return false
			}
			let Arr = []
			let constantNames = [
			'CUSTOMER_STATUS',
			'CUSTOMER_TYPE',
			'INTENTION_PRODUCT',
			'ACTIVITY_TYPE',
			'T_STATUS',
			'SEX', //性别
			'STUDENT_STATE',
			'P_STATUS',
			'O_STATUS',
			'PAY',
			'MESSAGE_TYPE',
			'CLIENT_TYPE',
			'UPDATE_LEVEL',
			'UPDATE_TYPE',
			'CLASS_TIME',
			'CLASS_TYPE', // 班级类型
			'CLASS_SHAPE',	//课程形式
			'COOPER_BRANCH',	//合作公司
			'COURSE_CYCLE',	//课程周期
			'POLITICAL',	//政治面貌
			'EDUCATION',	//学历
			'JOB_CHANNELS',	//招聘渠道
			'STUDY_SECTION',	//学段
			'RELATIONSHIP',	//与学生关系
			'GOAL_PURPOSE',	//与学生关系
			'CHANNEL_TYPE',	//渠道类型
			'APPROVAL_TYPE',
			'APPROVAL_FAILURE_TIME',
			'POSITION',
			'ISAUDITION',
			'AUTOMATIC_INCOME_TYPE',
			'AUTOMATIC_INCOME_APPROVAL',
			'AUTOMATIC_INCOME_STATUS',
			'APPROVAL_TYPE',//审批类型
			'APPROVAL_FLOW_STATUS',//业务审批流状态
			'REFUND_STATUS', // 颓废状态
			'REFUND_TYPE', // 退费性质
			'REFUND_ASCRIPTION', // 退费归属
			'REDUCE_STATUS', // 缩减产品状态
			'MULTI_STATUS',
			'AUDITIONS_STATUS', // 试听列表状态
			'JOB_TYPE', // 职位类型
			'COMMUNITY_TYPE', // 群类型
			'DATA_LEVEL', // 数据范围
			'ACTIVITY_STATUS',//活动状态
			'CLASS_TEAM_STATUS',//班级状态
			'PUSH_STATUS',//推送记录状态
			'TRUE-FALSE',//是否
			'RECHARGE_TYPE',//订单类型
			'CLASS_SIGN_STATUS',//课签状态
			'EQUIPMENT_TYPE', // 来源设备
			'WORKERS_STATUS',
			'CLASS_TYPE_ONLINE',
			'CLASS_WAY_SESSION',
			'CLASS_WAY_PRODUCT',
			'SCHEDULE_STATUS',
			'TIME_TABLE_PRODUCT_STATUS',
			'APPROVAL_LINE',
			'SCHEDULE_TYPE',
			'CLASS_ACTIVITY_RULE',//班课活动规则
			'SHIFT_STATUS',
			'WORK_ORDER_STATUS',
			'PLATFORM_PEOPLE',
			'EXAM_TYPE',
			'EXAMINEE_TYPE',
			'BATCH_TYPE',
			'DEP_PROPERTY',
			'BANK_OF_DEPOSIT',
			'STUDENT_SCHOOL_TYPE',
			'STUDENT_STATUS_PRO',
			'SMS_TIME_LENGTH',
			'PRODUCT_STATUS',
			'CHANNEL_DEPARTMENT' 
			]
			switch(this.groupName){
				case 'grade'://年級
				Arr = getConstantByKeyword('grade').map(item => {
					return {
						name : item.grade_name,
						key : item.id,
						disabled : item.status
					}
				})
				break;
				case 'invalidationReason'://无小原因
				Arr = getConstantByKeyword('invalidationReason').filter(data=>this.judgeState ? data.status==1 : true).map(item => {
					return {
						name : item.reason_content,
						key : item.id,
						disabled : item.status
					}
				})
				break;
				case 'channel':
				Arr = getConstantByKeyword('channel').map(item => {
					return {
						name : item.channel_name,
						key : item.id,
						disabled : item.status
					}
				})
				break;
				case 'channelSearch':
				Arr = getConstantByKeyword('channel').map(item => {
					return {
						name : item.channel_name,
						key : item.id,
						disabled : item.status
					}
				}).filter(item=>item.disabled==1)
				break;
				case 'filiale'://分公司
				Arr = this.convert(getConstantByKeyword('filiale')).map(item => {
					return {
						name : item.dep_name,
						key : item.id,
						disabled : item.status
					}
				})
				break;
				case 'filialeAuthor'://分公司登录人权限
				Arr = this.convert(getConstantByKeyword('filiale')).map(item => {
					return {
						name : item.dep_name,
						key : item.id,
						disabled : item.status
					}
				})
				if(this.userMess.branch_id){
					Arr = Arr.filter(item =>{
						return item.key == this.userMess.branch_id
					})
				}
				break
				case 'schoolAuthor'://分公司登录人权限下的校区
				Arr = this.convert(getConstantByKeyword('filiale')).map(item => {
					return {
						name : item.dep_name,
						key : item.id,
						child: item.child,
						disabled : item.status
					}
				})
				if(this.userMess.branch_id){
					Arr = Arr.filter(item =>{
						return item.key == this.userMess.branch_id
					})[0].child.map(item =>{
						return {
							name : item.dep_name,
							key : item.id,
							disabled : item.status,
							type: item.dep_type
						}
					}).filter(item =>{
						return item.type == 3
					})
				}
				break;
				case 'prductType':
				Arr = getConstantByKeyword('prductType').map(item => {
					return {
						name : item.type_name,
						key : item.product_type_key,//id
						disabled : item.status
					}
				})
				break;
				case 'givePrductType':
				Arr = getConstantByKeyword('prductType').filter(item =>{
					return item.product_type_key=='PT_PERSONALIZED_TEAM' || item.product_type_key=='PT_ONE_ON_ONE'
				}).map(item => {
					return {
						name : item.type_name,
						key : item.product_type_key,//id
						disabled : item.status
					}
				})
				break;
				case 'prductTypeID':
				Arr = getConstantByKeyword('prductType').map(item => {
					return {
						name : item.type_name,
						key : item.id,
						disabled : item.status
					}
				})
				break;
				case 'transfer_type':// 转余额类型
				Arr = [{ name : '余额转出', key : 1 }, { name : '余额转入', key : 2 }]
				break;
				case 'pay':// 新的缴费方式(筛选器)
				Arr = getConstantByKeyword('pay').map(item => {
					return {
						name : item.pay_name,
						key : item.id,
						disabled : item.status
					}
				})
				break;
				case 'curentPay': // 新的缴费方式
				this.getBranchPayMethod()
				break;
				case 'subject':
				Arr = getConstantByKeyword('subject').map(item => {
					return {
						name : item.subject_name,
						key : item.id,
						disabled : item.status
					}
				})
				break;
				case 'jdxksubject':
				this.getjdxkGradeSubject('subject')
				break;
				case 'jdxkgrade':
				this.getjdxkGradeSubject('grade')
				break;
				case 'school'://生院校
				this.fetch(model.getSchoolList).then( res =>{
					this.list = res.data.map(item => {
						return {
							name : item.school_name,
							key : item.id,
							disabled : item.status
						}
					})
				})
				break;
				case 'role'://审批角色
				this.fetch(model.getRoleList, {
					params : {
						pageSize : 0
					}
				}).then( res =>{
					this.list = res.map(item => {
						return {
							name : item.role_name,
							key : item.id,
							disabled : item.status
						}
					})
				})
				break;
				case 'adminUser'://社群变更管理员
				this.fetch(model.getPersonByDepId).then( res =>{
					this.list = res.map(item => {
						return {
							key: item.workers_position_id,
							name: item.user_name+'( '+item.role_name+' )',
							disabled : item.status
						}
					})
				})
				break;
				case 'community'://社群list
				this.fetch(model.getCommunity,{
					params: {
						page_size: 0
					}
				}).then(res =>{
					this.list = res.map(item => {
						return {
							key: item.id,
							name: item.community_name,
							disabled : item.status
						}
					})
				})
				break;
				case 'position'://职位
					this.fetch(model.getPositionList, {
						params : {
							page_size : 0,
							is_list : 1
						}
					}).then( res =>{
						this.list = res.filter(item => {
							return item.position_status == 1
						}).map(item => {
							return {
								name : item.position_name,
								key : item.id,
								disabled : item.status
							}
						})
					})
					break;
				case 'ITSSUBJECT'://ITS科目名称
					this.fetch(model.getItsSubjectList).then( res =>{
						this.list = res.data.map(item => {
							return {
								name : item.name,
								key : item.id,
								disabled : item.status
							}
						})
					})
					break;
				case 'ITSGRADE'://ITS年级名称
					this.fetch(model.getItsGradeList).then( res =>{
						this.list = res.data.map(item => {
							return {
								name : item.name,
								key : item.id,
								disabled : item.status
							}
						})
					})
					break;
				case 'CLASSTYPE'://班组形式
					this.fetch( model.normalClassTypeList,{
						params: { branch_id: this.userMess.branch_id}
					}).then( res =>{
						this.list = res.map(item => {
							return {
								name : item.class_name,
								key : item.id,
								disabled : item.status
							}
						})
					})
					break;
					case 'AGREEMENT'://协议内容
				this.fetch( model.getContractTemplateList,{
					params: {
						status: 1,
						page_size: 0
					}
				}).then( res =>{
					this.list = res.map(item => {
						return {
							name : item.template_name,
							key : item.id,
							disabled : item.status
						}
					})
				})
				break;
				case 'audition'://學管師
					this.getProduct('PT_ONE_ON_ONE')
					break;
				case 'school_admin'://學管師
					this.getWorkers(2)
					break;
				case 'counselor'://咨詢師
					this.getWorkers(1)
					break;
				case 'tempGroup'://班組客服
					this.getWorkers(3)
					break;
				case 'kefu'://客服
					this.getWorkers(4)
					break;
				case 'yesORNo':
					Arr = [{name:'是', key:'1'}, {name:'否', key:'0'}]
					break;
				case 'cover':
					Arr = [{name:'覆盖记录', key:'1'}, {name:'被覆盖记录', key:'2'}]
					break;
				case 'sign_status':
					Arr = [{name:'未签', key:'0'}, {name:'正常', key:'1'}, {name:'补签', key:'2'}]
					break;
				case 'signType':
					Arr = [{name:'正常', key:'1'}, {name:'旷课', key:'2'}]
					break;
				case 'college_type':
					Arr = [{name:'文科', key: '1'}, {name:'理科', key: '2'}]
					break;
				case 'college_batch':
					Arr = [{name:'一批本科', key: '1'}, {name:'二批本科', key: '2'}]
					break;
				case 'questionStatus':
					Arr = [{name:'未回复', key: '1'}, {name:'已回复', key: '2'}]
					break;
				case 'questionType':
					Arr = [{name:'建议', key: 1001}, {name:'需求', key: 1002}, {name:'问题', key: 1003}]
					break;
				case 'employeeStatus'://员工状态
					Arr = [{ name:'在职', key:'1'}, {name:'离职', key:'0' }]
					break;
				case 'searchWay'://搜索方式
					Arr = [{name:'手机号', key: 1 }, { name:'编号', key: 2}, {name:'姓名', key: 3 }]
					break;
				case 'roleStatus'://员工状态
					Arr = [{name:'试用期', key: 1 }, { name:'正式员工', key: 2}]
					break;
				case 'onOff'://停用启用
					Arr = [{name:'停用', key: 0 }, { name:'启用', key: 1}]
					break;
				case 'CLASS_TEAM_VOID'://班级作废
					Arr = [{name:'作废', key: 0 }, { name:'正常', key: 1}]
					break;
				case 'IS_DUE'://未到期 已到期
					Arr = [{name:'未到期', key: 1 }, { name:'已到期', key: 2}]
					break;
				case 'contractType'://首签 续签
					Arr = [{name:'首签', key: 1 }, { name:'续签', key: 2}]
					break;
				case 'open_class_type'://开班方式
					Arr = [{name:'手动开班', key: 1 }, { name:'自动开班', key: 2}]
					break;
				case 'tagType'://标签类型
					Arr = [{name:'客户标签', key: 1 }, { name:'内容标签', key: 2}]
					break;
				case 'IS_ASSIGN_WORKER'://是否分配
					Arr = [{name:'未分配', key: 0 }, { name:'已分配', key: 1}]
					break;
				case 'IS_RETURN_VISIT'://是否回访
					Arr = [{name:'未回访', key: 0 }, { name:'已回访', key: 1}]
					break;
				default:
					if(constantNames.includes(this.groupName)){
						Arr = this.getGroupData()
					}else{
						console.log('未定义的'+this.groupName)
					}
			}

			this.list = Arr.length>0 ? Arr : this.list
			typeof this.result == 'number' || !!this.result ? this.option = this.result : ''
		}

		getWorkers(type){
			this.fetch(model.getEmployeeDept,{//有校区获取校区下人员，没有校区的话获取当前分公司下所有对应人员，如果都没有显示所有
				router: this.userMess.branch_id || this.userMess.school_id ||this.userMess.department_id,
				params: {
					type: type
				}
			}).then( res =>{
				this.list = res.map(item => {
					return {
						name : item.user_name,
						key : item.id,
						disabled : item.status
					}
				})
			}, data =>{
				this.list = []
			})
		}

		getProduct(type){ //试听产品
			this.fetch(model.productionList,{
				params: {
					product_status: 1,
					product_type: type,
					school_id: this.userMess.school_id,
					page_size:10000
				}
			}).then( res =>{
				this.list = res.data.map(item => {
					return {
						name : item.product_name,
						key : item.id,
						disabled : item.status
					}
				})
			}, data =>{
				this.list =  []
			})
		}
		getBranchPayMethod(){ //获取分公司支付方式
			this.fetch(model.getBranchPayMethod).then( res =>{
				this.list = res.map(item => {
					return {
						name : item.pay_name,
						key : item.id,
						disabled : item.status
					}
				})
			}, data =>{
				this.list =  []
			})
		}
		getjdxkGradeSubject(type){ //获取jdxk年级科目
			this.fetch(model.getjdxkGradeSubject).then( res =>{
				if(type=='grade'){
					if(this.filter){
						/* 获取学段处理 */
						let study_section = (res.grade).filter(item =>{
							return item.grade==this.filter
						})[0]['grade_section']
						this.list = (res.grade).filter(item =>{
							return item.grade_section==study_section
						}).map(item => {
							return {
								name : item.grade_name,
								key : item.grade,
								disabled : item.status
							}
						})
					}else{
						this.list = (res.grade).map(item => {
							return {
								name : item.grade_name,
								key : item.grade,
								disabled : item.status
							}
						})
					}
				}
				if(type=='subject'){
					this.list = (res.subject).map(item => {
						return {
							name : item.subject_name,
							key : item.subject_id,
							disabled : item.status
						}
					})
				}

			}, data =>{
				this.list =  []
			})
		}

		getGroupData(){
			return getConstantByKeyword(this.groupName).map(item => {
				return {
					name : item.item_name,
					key : Number(item.item_value),
					disabled : item.status
				}
			})
		}

		visibleChange(value){
			if(this.visibleChange){
				this.$emit('isVisibleChange', value)
			}
		}

		change(val) {
			if(this.isResultName && val){
				this.$emit('update:resultName', this.list.find(item => item.key === val).name)
			}
			this.$emit('update:result', val)
			this.$emit('callback', val)
		}

		remoteMethod(query) {
            this.$emit('remotecallback', query)
        }
	}

</script>



// WEBPACK FOOTER //
// src/components/SelectTabs.vue